__turbopack_context__.v({
  "container": "index-module-scss-module__A0fnPW__container",
  "googleLogo": "index-module-scss-module__A0fnPW__googleLogo",
  "points": "index-module-scss-module__A0fnPW__points",
  "poweredby": "index-module-scss-module__A0fnPW__poweredby",
  "rating": "index-module-scss-module__A0fnPW__rating",
});
